<template>
  <div class="card mb-5 mb-xxl-8">
    <div v-if="isReady" class="card">
      <div class="card-header flex-wrap border-0 pt-6 pb-0">
        <div class="card-title">
          <h3 class="card-label">{{ $t('loyalty.list') }}</h3>
        </div>
        <div class="card-toolbar">
          <router-link v-if="can('loyalty_program_create') || can('loyalty_program_update')" :to="{ name: 'loyalty-programs' }" class="btn btn-sm btn-light-primary">
            {{ $t('loyalty.manage_link') }}
          </router-link>
        </div>
      </div>
      <div class="card-body">
        <p class="text-muted fs-7">{{ $t('loyalty.shop_view_hint') }}</p>
        <div v-if="programs.length === 0" class="text-muted text-center py-10">
          {{ $t('loyalty.empty') }}
        </div>
        <div v-else class="table-responsive">
        <table class="table align-middle table-row-bordered fs-6 gy-3">
          <thead>
            <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
              <th class="min-w-150px">{{ $t('loyalty.name') }}</th>
              <th class="min-w-150px">{{ $t('loyalty.earning_type') }}</th>
              <th class="min-w-100px">{{ $t('loyalty.rewards_count') }}</th>
              <th class="min-w-100px">{{ $t('loyalty.status') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="program in programs" :key="program.id">
              <td>{{ program.name }}</td>
              <td>{{ earningTypeLabel(program.earning_type) }}</td>
              <td>{{ program.rewards ? program.rewards.length : 0 }}</td>
              <td>
                <span :class="program.is_active ? 'badge badge-light-success' : 'badge badge-light-danger'">
                  {{ program.is_active ? $t('loyalty.active') : $t('loyalty.inactive') }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>
    </div>
    <div v-else class="card">
      <Loader />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import Loader from '@/components/Loader.vue'
import { useHasAbility } from '@/composables/hasAbility'

const store = useStore()
const route = useRoute()
const { can } = useHasAbility()

const isReady = ref(false)
const locale = computed(() => i18n.global.locale)

const programs = computed(() => store.getters['loyalty/getPrograms'])
const earningTypes = computed(() => store.getters['loyalty/getEarningTypes'])

function earningTypeLabel(value) {
  const found = (earningTypes.value || []).find((type) => type.value === value)
  return found ? found[locale.value] : value
}

async function loadForShop() {
  isReady.value = false
  await Promise.all([
    store.dispatch('loyalty/loadPrograms', route.params.id),
    store.dispatch('loyalty/loadEarningTypes'),
  ])
  isReady.value = true
}

onMounted(loadForShop)

// Vue Router réutilise ce composant quand on passe de la fiche d'une boutique
// à une autre (même route, seul :id change) — sans ce watcher, les programmes
// de fidélité restent ceux de l'ancienne boutique consultée.
watch(() => route.params.id, (newId, oldId) => {
  if (newId && newId !== oldId) {
    loadForShop()
  }
})
</script>
